import { z } from "zod";

export type LimitInfo = z.infer<typeof LimitInfoSchema>;
export const LimitInfoSchema = z.object({
  current: z.number(),
  limit: z.number(),
});
